import React, {Component} from 'react';
import {Alert} from '@homeaway/react-alerts';
import Experiment, {ExperimentProvider} from '@homeaway/react-experiment';
import {writeCookie, readCookie} from '../../utils/cookieHelpers';

// Styles
import './TravelerBanner.less';

export type AbacusEvaluationData = {
    experimentInstanceId: number;
    experimentKey: {
        experimentId: number;
        experimentName: string;
    };
    value: number;
};

export type Props = {
    labels: {
        important: string;
        travelerMsg: string;
        learnMore?: string;
        url?: string;
    };
    AbacusEvaluatedTests: {[string: string]: AbacusEvaluationData};
};

export type State = {
    isBannerDisabled: boolean;
};

class TravelerBanner extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            isBannerDisabled: true
        };
    }

    componentDidMount = () => {
        // prevent ssr render
        requestAnimationFrame(() => {
            this.setState({
                isBannerDisabled: !!readCookie(
                    'ha_covid_banner_disabled',
                    null,
                    false
                )
            });
        });
    };

    disableBanner = () => {
        writeCookie('ha_covid_banner_disabled', 'true', false, 1);
    };

    render() {
        const {labels, AbacusEvaluatedTests} = this.props;
        const {isBannerDisabled} = this.state;
        const {important, travelerMsg, learnMore, url} = labels;

        const msg = (
            <span>
                {important && <strong>{important} </strong>}
                {travelerMsg}
                {url && learnMore && (
                    <a href={`${url}`} target="_blank">
                        <strong> {learnMore}</strong>
                    </a>
                )}
            </span>
        );

        if (isBannerDisabled) {
            return null;
        }

        return (
            !isBannerDisabled && (
                <ExperimentProvider abacus={AbacusEvaluatedTests}>
                    <Experiment name={'vrbo_serp_pdp_covid_banner'} variant={1}>
                        <div className="TravelerBanner">
                            <Alert
                                msg={msg}
                                dismissible
                                svgClassName="text-inverse"
                                onAlertClosed={this.disableBanner}
                            />
                        </div>
                    </Experiment>
                </ExperimentProvider>
            )
        );
    }
}

export default TravelerBanner;
